import Navbar from 'react-bootstrap/esm/Navbar';
import Button from '../UI/button';
import SvgIcon from '../SVG/svg';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

type Props = {
  itemCount: number;
  setSearchText?: (searchText: string) => void;
};
const MapNavbar = ({ itemCount = 0, setSearchText }: Props) => {
  const navigate = useNavigate();

  const handleInputChange = (event: React.KeyboardEvent<HTMLInputElement>) => {
    console.log('input change event', event);
    if (event.key === 'Enter' && setSearchText !== undefined) {
      const input = event.target as HTMLInputElement;
      setSearchText(input.value || ''); // Call the function with the entered value
      event.preventDefault(); // Prevent the default form submission behavior
    }
  };

  return (
    <Navbar className='map-navbar d-flex justify-content-between align-items-center'>
      <Navbar.Brand>
        <h5>Map</h5>
        <p>{itemCount + ' '} items</p>
      </Navbar.Brand>
      <Form className='map-navbar-form flex-grow-1'>
        <Form.Group className='input-wrapper position-relative'>
          <Form.Control
            className='rounded-pill '
            type='text'
            placeholder='Search for popular places and add them to your trip'
            id='searchText'
            onKeyDown={handleInputChange} // Add onKeyDown handler
          />
          <Button
            variant='transparent'
            type='submit'
            className='search-btn position-absolute'
          >
            <SvgIcon type='search' />
          </Button>
        </Form.Group>
      </Form>
      <div
        className='d-flex align-items-center'
        style={{ gap: '24px' }}
      >
        <Button
          px={20}
          variant='outline-dark'
          size='md'
          width='full'
        >
          Itinerary
        </Button>
        <Button
          className='text-nowrap px-4'
          variant='primary'
          size='md'
          width='full'
        >
          Send Map to Phone
        </Button>
        <Button
          hover={{ scale: true }}
          className='p-0'
          variant='transparent'
        >
          <SvgIcon type='share' />
        </Button>
        <Button
          hover={{ scale: true }}
          className='p-0'
          variant='transparent'
          onClick={() => navigate(-1)}
        >
          <SvgIcon type='close' />
        </Button>
      </div>
    </Navbar>
  );
};
export default MapNavbar;
